import React, { useState, useEffect } from 'react';
import { Calendar, Clock, CheckCircle, Video } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';

export default function MeetingPage() {
  const { api } = useAuth();
  const [slots, setSlots] = useState([]);
  const [booked, setBooked] = useState(null);
  const [selected, setSelected] = useState('');
  const [loading, setLoading] = useState(true);
  const [booking, setBooking] = useState(false);

  useEffect(() => {
    api('get', '/api/portal/dashboard').then(r => { if (r.data?.meeting) setBooked(r.data.meeting); });
    api('get', '/api/portal/meetings/slots').then(r => setSlots(r.data.slots || [])).finally(() => setLoading(false));
  }, []);

  const handleBook = async () => {
    if (!selected) { toast.error('Selecteer een tijdstip'); return; }
    setBooking(true);
    try {
      const r = await api('post', '/api/portal/meetings/book', { slot_id: selected });
      setBooked(r.data);
      toast.success('Meeting ingepland! Bevestiging verzonden naar uw e-mailadres.');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Fout bij inplannen. Probeer opnieuw.');
    } finally { setBooking(false); }
  };

  // Group slots by date
  const byDate = slots.reduce((acc, s) => { (acc[s.date] = acc[s.date] || []).push(s); return acc; }, {});
  const days_nl = ['zo','ma','di','wo','do','vr','za'];
  const months_nl = ['','jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'];

  if (booked) return (
    <div className="max-w-lg">
      <h1 className="text-2xl font-bold text-white mb-6">Kick-off Meeting</h1>
      <div className="bg-[#0f172a] rounded-2xl border border-green-500/30 p-8 text-center">
        <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <CheckCircle className="w-8 h-8 text-green-400" />
        </div>
        <h2 className="text-white font-bold text-xl mb-2">Meeting ingepland!</h2>
        <div className="bg-white/5 rounded-xl p-4 mt-4 text-left space-y-3">
          <div className="flex items-center gap-3"><Calendar className="w-5 h-5 text-[#D4A017]" /><span className="text-white">{booked.date}</span></div>
          <div className="flex items-center gap-3"><Clock className="w-5 h-5 text-[#D4A017]" /><span className="text-white">{booked.time}</span></div>
          <div className="flex items-center gap-3"><Video className="w-5 h-5 text-[#D4A017]" />{booked.meeting_link ? <a data-testid="meeting-join-link" href={booked.meeting_link} className="text-[#D4A017] hover:underline">Deelnemen aan meeting</a> : <span data-testid="meeting-link-pending" className="text-white">De meetinglink volgt per e-mail.</span>}</div>
        </div>
        <p className="text-[#64748b] text-sm mt-4">U ontvangt ook een bevestigingsmail met alle details.</p>
      </div>
    </div>
  );

  return (
    <div className="max-w-3xl">
      <h1 className="text-2xl font-bold text-white mb-2">Kick-off Meeting Plannen</h1>
      <p className="text-[#64748b] mb-6">Kies een moment voor uw kick-off meeting met ons team.</p>
      {loading ? (
        <div className="flex justify-center py-12"><div className="w-8 h-8 border-2 border-[#D4A017] border-t-transparent rounded-full animate-spin" /></div>
      ) : (
        <div className="space-y-4">
          {Object.entries(byDate).slice(0, 10).map(([date, dateSlots]) => {
            const d = new Date(date + 'T12:00:00');
            const label = `${days_nl[d.getDay()]} ${d.getDate()} ${months_nl[d.getMonth() + 1]}`;
            return (
              <div key={date} className="bg-[#0f172a] rounded-2xl border border-white/5 p-5">
                <h3 className="text-[#D4A017] font-bold text-sm uppercase tracking-wider mb-3">{label}</h3>
                <div className="flex flex-wrap gap-2">
                  {dateSlots.map(s => (
                    <button key={s.slot_id} onClick={() => setSelected(s.slot_id)}
                      className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                        selected === s.slot_id ? 'bg-[#D4A017] text-[#0f172a]' : 'bg-white/5 text-[#94a3b8] hover:bg-white/10 hover:text-white'
                      }`}>
                      {s.time}
                    </button>
                  ))}
                </div>
              </div>
            );
          })}
          {selected && (
            <div className="bg-[#D4A017]/10 border border-[#D4A017]/30 rounded-xl p-4 flex items-center justify-between">
              <p className="text-white text-sm">Geselecteerd: <strong>{selected.replace('T', ' om ').replace(':00', ':00 uur')}</strong></p>
              <button onClick={handleBook} disabled={booking}
                className="bg-[#D4A017] hover:bg-[#B8860B] text-[#0f172a] font-bold px-5 py-2 rounded-lg text-sm transition-all disabled:opacity-60">
                {booking ? 'Inplannen...' : 'Bevestig meeting'}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
